import axios from 'axios';

// Handle the Authorization header if token exists in localStorage


const api = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    timeout: 10000, 
    headers: { 'Content-Type': 'application/json' }
});
console.log(api.getUri)
const tokenFromStorage = localStorage.getItem('token');

if (tokenFromStorage) {

    api.defaults.headers.common['Authorization'] = `Bearer ${tokenFromStorage}`;
}

// Response interceptor for handling errors
api.interceptors.response.use(
    response => response,
    error => {

        return Promise.reject(error);
    }
);

export default api;
